import { Component, HostListener, ElementRef, OnInit } from '@angular/core';

@Component({
    selector: 'app-homefr',
    templateUrl: './homefr.component.html',
    styleUrls: ['./homefr.component.scss'],
    standalone: false
})
export class HomefrComponent implements OnInit {
  //enrolText:string = "To enrol, please speak to your healthcare professional.";
  close: string = "Fermer la fenêtre";
  enrollmenth3: string = "Inscription";
  enrollmentp: string = "Après une inscription rapide et facile, une infirmière gestionnaire de dossier vous appellera pour vous intégrer et vous guider dans les prochaines étapes.";
  enrollmentpath: string = "/assets/img/enrollment_box_icon.svg"

  ordersuupliesh3: string = "Commander des fournitures";
  ordersuupliesp: string = "Vous obtiendrez de l’aide pour commander des fournitures auxiliaires en ligne et configurer la livraison.";
  ordersuupliespath: string = "/assets/img/ordering_supplies_box-icon.svg";

  productcoorh3: string = "Coordination du produit";
  productcoorp: string = "L’infirmière responsable de votre dossier programmera le ramassage de votre produit avec la banque de sang ou la pharmacie.";
  productcoorpath: string = "/assets/img/product_coordination_box_icon.svg";

  trainingsuph3: string = "Formation et soutien";
  trainingsupp: string = "Vous recevrez un soutien continu et personnalisé tout au long de votre traitement de la part de notre équipe d’infirmières autorisées, avec une formation individuelle illimitée à domicile ou en clinique sur la façon de vous administrer votre traitement vous-même.";
  trainingsuppath: string = "/assets/img/training_box_icon.svg";

  physicianh3: string = "Rapports au médecin et à l’équipe de soins de santé";
  physicianp: string = "Notre équipe enverra des notes récapitulatives à votre médecin à chaque étape pour assurer un soutien constant.";
  physicianpath: string = "/assets/img/reports_box_icon.svg";

  enrollment: boolean = false;
  orderingsupplies: boolean = false;
  productcoordination: boolean = false;
  trainingsupport: boolean = false;
  reportstophysician: boolean = false;
  scrollBottom: any;
@HostListener('window:scroll', ['$event.target'])
onscroll(e:any)  {
    this.scrollBottom = e.scrollingElement.scrollTop;
    this.checkHeightToAnimate();
  }
  constructor( private elementRef: ElementRef) { }
  checkHeightToAnimate() {
    try {
      if (this.checkScrollHeightBottom(this.scrollBottom,(this.elementRef.nativeElement.querySelector('#HCPs_fr').offsetTop)))
        this.elementRef.nativeElement.querySelector('.hcp-support-image').classList.add('pre-animate');
      if (this.checkScrollHeightBottom(this.scrollBottom,(this.elementRef.nativeElement.querySelector('#sec_cslnews').offsetTop-500))){
        this.elementRef.nativeElement.querySelector('.csl_news').classList.add('pre-animate');
        setTimeout(() => {
          this.elementRef.nativeElement.querySelectorAll('.csl_news').forEach(element => {
            element.classList.add('display_news_img');
          })
        }, 200);
      }
    } catch (e) {}
}
  checkScrollHeightBottom(x: any, y: any) {
    if (x >= (y+200))
        return true;
    else
        return false;
}

  ngOnInit() {
  }
 
  showpopup(id: string) {
    if (id == 'reportstophysician') {
      this.reportstophysician = true;
      this.enrollment = false;
      this.productcoordination = false;
      this.orderingsupplies = false;
      this.trainingsupport = false;
    }
    else if (id == 'enrollment') {
      this.reportstophysician = false;
      this.enrollment = true;
      this.productcoordination = false;
      this.orderingsupplies = false;
      this.trainingsupport = false;
    }
    else if (id == 'productcoordination') {
      this.reportstophysician = false;
      this.enrollment = false;
      this.productcoordination = true;
      this.orderingsupplies = false;
      this.trainingsupport = false;
    }
    else if (id == 'orderingsupplies') {
      this.reportstophysician = false;
      this.enrollment = false;
      this.productcoordination = false;
      this.orderingsupplies = true;
      this.trainingsupport = false;
    }
    else if (id == 'trainingsupport') {
      this.reportstophysician = false;
      this.enrollment = false;
      this.productcoordination = false;
      this.orderingsupplies = false;
      this.trainingsupport = true;
    }
  }

  popupclose() {
    this.reportstophysician = false;
    this.enrollment = false;
    this.productcoordination = false;
    this.orderingsupplies = false;
    this.trainingsupport = false;
  }
  // enrolTextOn(){
  //   this.enrolText = "To register, please speak to your healthcare professional."
  // }
  // enrolTextOff(){
  //   this.enrolText = "To enrol, please speak to your healthcare professional."
  // }
}
